import { AlertTriangle, Check, Pencil } from "lucide-react";

// 422/423: části okna směny sdílené s panelem party v deníku (stejný vzhled všude).
// Poznámky nahoře (dřív štítky varování 161) — stejné pořadí, ale s vysvětlením.
export function Note({ tone = "info", icon: Icon = AlertTriangle, title, children, testid }) {
  const box = { bad: "bg-destructive/10", warn: "bg-amber-500/10", info: "bg-background dark:bg-secondary" }[tone];
  const ic = { bad: "text-destructive", warn: "text-amber-600 dark:text-amber-400", info: "text-muted-foreground" }[tone];
  return (
    <div className={`flex gap-2.5 items-start rounded-[16px] px-3.5 py-3 text-[13.5px] ${box}`} data-testid={testid}>
      <Icon size={17} className={`shrink-0 mt-0.5 ${ic}`} />
      <div className="min-w-0"><b className="block font-bold">{title}</b>{children && <span className="text-muted-foreground break-words">{children}</span>}</div>
    </div>
  );
}

export function Section({ icon: Icon, title, action, children, testid, ...rest }) {
  return (
    <section className="space-y-2.5 min-w-0" data-testid={testid} {...rest}>
      <div className="flex items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 text-[14.5px] font-bold">{Icon && <Icon size={17} className="text-brand shrink-0" />}{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}

// Krok osy Příchod → Přestávka → Odchod → Schválení (Účtenka, 422)
export function Step({ dot, label, sub, value, onEdit, open, editKey, children, last, prefix = "shift" }) {
  const dotCls = { ok: "bg-success border-success", bad: "bg-destructive border-destructive", now: "bg-card border-brand ring-4 ring-brand/15", idle: "bg-card border-muted-foreground/50" }[dot];
  return (
    <div className={`relative pl-7 py-3 ${last ? "" : "border-b border-border/60"}`} data-testid={`${prefix}-step-${editKey}`}>
      {!last && <span className="absolute left-[6px] top-[34px] -bottom-[14px] w-[2px] bg-border" aria-hidden="true" />}
      <span className={`absolute left-0 top-[17px] h-[14px] w-[14px] rounded-full border-2 z-[1] ${dotCls}`} aria-hidden="true" />
      <div className="flex items-center justify-between gap-3 min-w-0">
        <div className="min-w-0"><b className="block text-[14.5px] font-bold">{label}</b><div className="text-[12.5px] text-muted-foreground">{sub}</div></div>
        <div className="flex items-center gap-2 shrink-0 text-lg font-black tabular-nums whitespace-nowrap">
          {value}
          {onEdit && (
            <button type="button" onClick={onEdit} aria-expanded={open} aria-label={`Upravit ${label.toLowerCase()}`} data-testid={`${prefix}-edit-${editKey}`}
              className={`h-8 w-8 rounded-full border grid place-items-center transition-colors ${open ? "bg-foreground text-background border-foreground" : "bg-card border-border text-muted-foreground hover:text-foreground"}`}>
              {open ? <Check size={15} /> : <Pencil size={14} />}
            </button>
          )}
        </div>
      </div>
      {open && <div className="mt-3 flex flex-wrap items-center gap-2.5">{children}</div>}
    </div>
  );
}
